import { jsx as t, jsxs as k, Fragment as J } from "react/jsx-runtime";
import { AlertGroup as en, Alert as tn, AlertVariant as _e, AlertActionCloseButton as nn, Page as rn, Modal as vt, ModalVariant as an, TextContent as ln, Text as ke, Button as q, Spinner as bt, FormHelperText as ze, HelperText as Je, HelperTextItem as Ye, Popover as sn, Icon as qe, FormGroup as Ct, NumberInput as on, ValidatedOptions as W, InputGroup as xe, InputGroupItem as Ue, TextInput as Te, Select as Ee, SelectList as Ae, SelectOption as Qe, MenuToggle as me, MenuToggleStatus as Xe, TextInputGroup as kt, TextInputGroupMain as It, ChipGroup as Ze, Chip as et, TextInputGroupUtilities as wt, Switch as cn, TextArea as St, FileUpload as dn, Title as un, Card as hn, CardHeader as fn, CardTitle as mn, CardBody as pn, Grid as gn, GridItem as st, PageSection as yn, JumpLinks as vn, JumpLinksItem as bn, ButtonVariant as we, Checkbox as Cn, Radio as kn, MenuFooter as In, Dropdown as wn, DropdownList as Sn, DropdownItem as ot, Masthead as xn, MastheadToggle as Tn, PageToggleButton as En, MastheadBrand as An, MastheadContent as Rn, Toolbar as Ie, ToolbarContent as $e, ToolbarItem as z, Avatar as Dn, Bullseye as Fn, EmptyState as On, EmptyStateIcon as ct, EmptyStateHeader as Pn, EmptyStateBody as Vn, EmptyStateFooter as Ln, EmptyStateActions as Mn, SearchInput as Bn, Divider as Nn, Pagination as _n, Badge as qn } from "@patternfly/react-core";
import { createContext as xt, useContext as Tt, useRef as ne, useEffect as ae, useCallback as he, useState as A, useMemo as $, isValidElement as Et, forwardRef as Un, useId as At, Fragment as Rt, Children as Dt, Component as $n } from "react";
import { useTranslation as U } from "react-i18next";
import { NetworkError as Ft } from "@keycloak/keycloak-admin-client";
import Kn from "keycloak-js";
import { ExclamationCircleIcon as Hn, ExclamationTriangleIcon as jn, HelpIcon as Gn, EyeIcon as Wn, EyeSlashIcon as zn, TimesIcon as Ot, CubeIcon as Jn, PaypalIcon as Yn, InstagramIcon as Qn, BitbucketIcon as Xn, MicrosoftIcon as Zn, TwitterIcon as er, StackOverflowIcon as tr, OpenshiftIcon as nr, LinkedinIcon as rr, GoogleIcon as ar, GitlabIcon as lr, FacebookSquareIcon as ir, GithubIcon as sr, MinusCircleIcon as or, PlusCircleIcon as Pt, EllipsisVIcon as cr, BarsIcon as dr, SearchIcon as ur, SyncAltIcon as hr } from "@patternfly/react-icons";
import { useFormContext as Re, Controller as oe, useController as De, FormProvider as fr, useWatch as mr } from "react-hook-form";
import { get as _, intersectionBy as pr, cloneDeep as gr } from "lodash-es";
import be from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as yr } from "@patternfly/react-styles";
import { Table as vr, TableVariant as br, Thead as Cr, Tr as Ce, Th as Me, Tbody as dt, Td as le, ExpandableRowContent as kr, ActionsColumn as Ir, cellWidth as wr, TableText as Sr } from "@patternfly/react-table";
import './main.css';function tt(e, n) {
  const r = xt(n);
  return r.displayName = e, r;
}
const xr = ["error", "errorMessage"], Be = "error_description";
function Tr(e) {
  if (typeof e == "string")
    return e;
  if (e instanceof Ft)
    return Vt(e.responseData);
  if (e instanceof Error)
    return e.message;
  throw new Error("Unable to determine error message.");
}
function Er(e) {
  if (!(e instanceof Ft))
    return;
  const n = e.responseData;
  return Ar(n);
}
function Ar(e) {
  if (typeof e == "object" && e !== null && Be in e && typeof e[Be] == "string")
    return e[Be];
}
function Vt(e) {
  if (!(typeof e != "object" || e === null))
    for (const n of xr) {
      const r = e[n];
      if (typeof r == "string")
        return r;
    }
}
const Rr = () => Math.floor(Math.random() * 1e3);
function Dr(e) {
  return e != null;
}
function nt(e) {
  const n = Tt(e);
  if (Dr(n))
    return n;
  throw new Error(
    `No provider found for ${e.displayName ? `the '${e.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Fr() {
  const e = ne(!1), n = ne(/* @__PURE__ */ new Set());
  ae(() => (e.current = !1, () => {
    e.current = !0, r();
  }), []);
  function r() {
    n.current.forEach((a) => clearTimeout(a)), n.current.clear();
  }
  return he((a, l) => {
    if (e.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, l));
    n.current.add(i);
    function s() {
      n.current.delete(i), a();
    }
    return function() {
      clearTimeout(i), n.current.delete(i);
    };
  }, []);
}
function Or({ alerts: e, onCloseAlert: n }) {
  return /* @__PURE__ */ t(
    en,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: e.map(({ id: r, variant: a, message: l, description: i }, s) => /* @__PURE__ */ t(
        tn,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: _e[a],
          component: "p",
          variantLabel: "",
          title: l,
          actionClose: /* @__PURE__ */ t(
            nn,
            {
              title: l,
              onClose: () => n(r)
            }
          ),
          children: i && /* @__PURE__ */ t("p", { children: i })
        },
        r
      ))
    }
  );
}
const Pr = 8e3, Lt = tt(
  "AlertContext",
  void 0
), Ua = () => nt(Lt), Vr = ({ children: e }) => {
  const { t: n } = U(), r = Fr(), [a, l] = A([]), i = (c) => l((u) => u.filter((h) => h.id !== c)), s = he(
    (c, u = _e.success, h) => {
      const m = {
        id: Rr(),
        message: c,
        variant: u,
        description: h
      };
      l((p) => [m, ...p]), r(() => i(m.id), Pr);
    },
    [r]
  ), o = he(
    (c, u) => {
      const h = n(c, { error: Tr(u) }), m = Er(u);
      s(h, _e.danger, m);
    },
    [s, n]
  ), d = $(() => ({ addAlert: s, addError: o }), [s, o]);
  return /* @__PURE__ */ k(Lt.Provider, { value: d, children: [
    /* @__PURE__ */ t(Or, { alerts: a, onCloseAlert: i }),
    e
  ] });
}, Lr = (e) => {
  const { t: n, i18n: r } = U(), a = e.error, l = Mr(a), i = Vt(a);
  console.error(a);
  function s() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ t(rn, { children: /* @__PURE__ */ t(
    vt,
    {
      variant: an.small,
      title: n("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ t(q, { variant: "primary", onClick: s, children: n("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ t(ln, { children: l ? /* @__PURE__ */ t(ke, { children: n(l) }) : i && r.exists(i) ? /* @__PURE__ */ t(ke, { children: n(i) }) : /* @__PURE__ */ t(ke, { children: n("somethingWentWrongDescription") }) })
    }
  ) });
};
function Mr(e) {
  return e instanceof Error ? e.message : null;
}
function Br(e, n, r) {
  const [a, l] = A(
    () => e.getItem(n) ?? r
  ), i = he((s) => {
    l(s), e.setItem(n, s);
  }, []);
  return ae(() => {
    l(e.getItem(n) ?? r), window.addEventListener("storage", s);
    function s(o) {
      o.storageArea === e && (o.key === null || o.key === n) && l(o.newValue ?? r);
    }
    return () => window.removeEventListener("storage", s);
  }, [e, n]), [a, i];
}
function Mt(e, n, r) {
  const a = $(
    () => JSON.stringify(r),
    [r]
  ), [l, i] = Br(
    e,
    n,
    a
  ), s = $(() => JSON.parse(l), [l]), o = he(
    (d) => i(JSON.stringify(d)),
    []
  );
  return [s, o];
}
const Bt = tt(
  "HelpContext",
  void 0
), Nr = () => nt(Bt), _r = ({ children: e }) => {
  const [n, r] = Mt(localStorage, "helpEnabled", !0);
  function a() {
    r(!n);
  }
  return /* @__PURE__ */ t(Bt.Provider, { value: { enabled: n, toggleHelp: a }, children: e });
}, qr = () => xt(void 0);
let Ke;
const $a = () => {
  const e = Tt(
    Ke
  );
  if (!e)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return e;
}, Ka = ({
  environment: e,
  keycloak: n,
  children: r
}) => {
  Ke = qr();
  const a = ne(!1), [l, i] = A(!!n), [s, o] = A(), d = $(() => {
    if (n)
      return n;
    const c = new Kn({
      url: e.serverBaseUrl,
      realm: e.realm,
      clientId: e.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [e, n]);
  return ae(() => {
    if (n || a.current)
      return;
    d.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      responseMode: "query",
      scope: e.scope,
      // 静默会话检查：刷新页面时在隐藏 iframe 里恢复 SSO 会话，
      // 避免每次刷新都整页重定向到 Keycloak 再跳回（可见闪现）。
      // 回调页由本应用静态目录提供：apps/admin-ui/public/silent-check-sso.html
      silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`
    }).then((u) => {
      if (!u) {
        d.login();
        return;
      }
      i(!0);
    }).catch((u) => o(u)), a.current = !0;
  }, [d, n]), s ? /* @__PURE__ */ t(Lr, { error: s }) : l ? /* @__PURE__ */ t(Ke.Provider, { value: { environment: e, keycloak: d }, children: /* @__PURE__ */ t(Vr, { children: /* @__PURE__ */ t(_r, { children: r }) }) }) : /* @__PURE__ */ t(
    "div",
    {
      style: {
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ t(bt, { style: { width: "3.375rem", height: "3.375rem" } })
    }
  );
};
function Ha() {
  const n = document.getElementById("environment")?.textContent;
  if (typeof n != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(n);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const ja = ({
  modalTitle: e,
  continueLabel: n,
  cancelLabel: r,
  buttonTitle: a,
  isDisabled: l,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: o,
  component: d = q,
  children: c,
  ...u
}) => {
  const [h, m] = A(!1);
  return /* @__PURE__ */ k(J, { children: [
    /* @__PURE__ */ t(
      d,
      {
        variant: i,
        onClick: () => m(!0),
        isDisabled: l,
        "data-testrole": s,
        children: a
      }
    ),
    /* @__PURE__ */ t(
      vt,
      {
        variant: "small",
        ...u,
        title: e,
        isOpen: h,
        onClose: () => m(!1),
        actions: [
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                m(!1), o();
              },
              children: n
            },
            "confirm"
          ),
          /* @__PURE__ */ t(
            q,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => m(!1),
              children: r
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, Nt = ({ message: e, ...n }) => /* @__PURE__ */ t(ze, { ...n, children: /* @__PURE__ */ t(Je, { children: /* @__PURE__ */ t(Ye, { icon: /* @__PURE__ */ t(Hn, {}), variant: "error", children: e }) }) }), _t = ({
  helpText: e,
  fieldLabelId: n,
  noVerticalAlign: r = !0,
  unWrap: a = !1,
  isRecommendation: l = !1
}) => {
  const { enabled: i } = Nr(), s = l ? jn : Gn;
  return i ? /* @__PURE__ */ t(sn, { bodyContent: e, children: /* @__PURE__ */ k(J, { children: [
    !a && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "data-testid": `help-label-${n}`,
        "aria-label": n,
        onClick: (o) => o.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ t(
          qe,
          {
            isInline: r,
            status: l ? "warning" : void 0,
            children: /* @__PURE__ */ t(s, {})
          }
        )
      }
    ),
    a && /* @__PURE__ */ t(
      qe,
      {
        isInline: r,
        status: l ? "warning" : void 0,
        children: /* @__PURE__ */ t(s, {})
      }
    )
  ] }) }) : null;
};
function ce(e) {
  if (!(typeof e > "u" || e instanceof RegExp))
    return typeof e == "object" ? e.value : e;
}
const Y = ({
  id: e,
  name: n,
  label: r,
  labelIcon: a,
  error: l,
  children: i,
  ...s
}) => /* @__PURE__ */ k(
  Ct,
  {
    label: r || n,
    fieldId: e || n,
    labelIcon: Et(a) ? a : a ? /* @__PURE__ */ t(_t, { helpText: a, fieldLabelId: e || n }) : void 0,
    ...s,
    children: [
      i,
      l && /* @__PURE__ */ t(Nt, { "data-testid": `${n}-helper`, message: l.message })
    ]
  }
), Ga = ({
  name: e,
  label: n,
  controller: r,
  labelIcon: a,
  ...l
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = Re();
  return /* @__PURE__ */ t(
    Y,
    {
      name: e,
      label: n,
      isRequired: r.rules?.required === !0,
      error: s[e],
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...r,
          name: e,
          control: i,
          render: ({ field: o }) => {
            const d = !!r.rules?.required, c = ce(r.rules?.min), u = o.value ?? r.defaultValue, h = (m) => o.onChange(
              c !== void 0 ? Math.max(m, Number(c)) : m
            );
            return /* @__PURE__ */ t(
              on,
              {
                ...l,
                id: e,
                value: u,
                validated: s[e] ? W.error : W.default,
                required: d,
                min: Number(c),
                max: Number(r.rules?.max),
                onPlus: () => h(u + 1),
                onMinus: () => h(u - 1),
                onChange: (m) => {
                  const p = Number(m.currentTarget.value);
                  h(isNaN(p) ? r.defaultValue : p);
                }
              }
            );
          }
        }
      )
    }
  );
}, Ur = ({
  hasReveal: e = !0,
  innerRef: n,
  ...r
}) => {
  const { t: a } = U(), [l, i] = A(!0);
  return /* @__PURE__ */ k(xe, { children: [
    /* @__PURE__ */ t(Ue, { isFill: !0, children: /* @__PURE__ */ t(
      Te,
      {
        ...r,
        type: l ? "password" : "text",
        ref: n
      }
    ) }),
    e && /* @__PURE__ */ t(
      q,
      {
        variant: "control",
        "aria-label": a("showPassword"),
        onClick: () => i(!l),
        children: l ? /* @__PURE__ */ t(Wn, {}) : /* @__PURE__ */ t(zn, {})
      }
    )
  ] });
}, qt = Un(
  (e, n) => /* @__PURE__ */ t(Ur, { ...e, innerRef: n })
);
qt.displayName = "PasswordInput";
const Wa = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { field: i, fieldState: s } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ k(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: s.error,
      children: [
        /* @__PURE__ */ t(
          qt,
          {
            isRequired: a,
            id: e.name,
            "data-testid": e.name,
            validated: s.error ? W.error : W.default,
            isDisabled: e.isDisabled,
            ...r,
            ...i
          }
        ),
        e.helperText && /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: /* @__PURE__ */ t(Ye, { children: e.helperText }) }) })
      ]
    }
  );
}, $r = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  isDisabled: o,
  isFullWidth: d = !0,
  onSelect: c,
  ...u
}) => {
  const {
    control: h,
    formState: { errors: m }
  } = Re(), [p, y] = A(!1), R = ce(i.rules?.required) === !0;
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: R,
      error: _(m, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: h,
          render: ({ field: { onChange: g, value: f } }) => /* @__PURE__ */ t(
            Ee,
            {
              ...u,
              variant: "default",
              onClick: () => y(!p),
              onOpenChange: () => y(!1),
              selected: te(a) ? a.filter(
                (b) => Array.isArray(f) ? f.includes(b.key) : f === b.key
              ).map((b) => b.value) : f,
              toggle: (b) => /* @__PURE__ */ t(
                me,
                {
                  id: e || n,
                  ref: b,
                  onClick: () => y(!p),
                  isExpanded: p,
                  isFullWidth: d,
                  status: _(m, n) ? Xe.danger : void 0,
                  "aria-label": r,
                  isDisabled: o,
                  children: te(a) ? a.find(
                    (E) => E.key === (Array.isArray(f) ? f[0] : f)
                  )?.value : f
                }
              ),
              onSelect: (b, E) => {
                const I = E?.toString(), v = Array.isArray(f) ? [I] : I;
                c ? c(v, g) : g(v), y(!1);
              },
              isOpen: p,
              children: /* @__PURE__ */ t(Ae, { "data-testid": `select-${n}`, children: [...a, ...l].map((b) => /* @__PURE__ */ t(
                Qe,
                {
                  value: ie(b),
                  description: !fe(b) && "description" in b ? b.description : void 0,
                  children: fe(b) ? b : b.value
                },
                ie(b)
              )) })
            }
          )
        }
      )
    }
  );
}, ee = (e) => fe(e) ? e : e.value, Kr = ({
  id: e,
  name: n,
  label: r,
  options: a,
  selectedOptions: l = [],
  controller: i,
  labelIcon: s,
  placeholderText: o,
  onFilter: d,
  variant: c,
  isFullWidth: u = !0,
  ...h
}) => {
  const {
    control: m,
    formState: { errors: p }
  } = Re(), [y, R] = A(!1), [g, f] = A(""), [b, E] = A(0), [I, v] = A([]), T = ne(), B = ce(i.rules?.required) === !0, F = c === ue.typeaheadMulti, P = $(
    () => [
      ...a.filter(
        (C) => !l.map((w) => ee(w)).includes(ee(C))
      ),
      ...l
    ],
    [l, a]
  ), K = P.filter(
    (C) => ee(C).toLowerCase().startsWith(g.toLowerCase())
  ), H = (C, w) => {
    w.value.includes(C) ? (w.onChange(w.value.filter((x) => x !== C)), te(a) && v(
      I.filter((x) => x.key !== C)
    )) : (w.onChange([...w.value, C]), te(P) && v([
      ...I,
      P.find((x) => x.key === C)
    ]));
  }, j = (C, w) => {
    const x = K[b];
    switch (R(!0), C.key) {
      case "Enter": {
        C.preventDefault(), f(F ? "" : ee(x)), H(ie(x), w), R(!1), E(0);
        break;
      }
      case "Tab":
      case "Escape": {
        R(!1), w.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === ue.typeahead && w.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        C.preventDefault();
        let L = 0;
        C.key === "ArrowUp" && (b === 0 ? L = a.length - 1 : L = b - 1), C.key === "ArrowDown" && (b === a.length - 1 ? L = 0 : L = b + 1), E(L);
        break;
      }
    }
  };
  return /* @__PURE__ */ t(
    Y,
    {
      id: e,
      name: n,
      label: r,
      isRequired: B,
      error: _(p, n),
      labelIcon: s,
      children: /* @__PURE__ */ t(
        oe,
        {
          ...i,
          name: n,
          control: m,
          render: ({ field: C }) => /* @__PURE__ */ t(
            Ee,
            {
              ...h,
              onOpenChange: () => R(!1),
              selected: te(P) ? P.filter(
                (w) => Array.isArray(C.value) ? C.value.includes(w.key) : C.value === w.key
              ).map((w) => w.value) : C.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (w) => /* @__PURE__ */ t(
                me,
                {
                  ref: w,
                  id: e || n,
                  variant: "typeahead",
                  onClick: () => {
                    R(!y), T.current?.focus();
                  },
                  isExpanded: y,
                  isFullWidth: u,
                  status: _(p, n) ? Xe.danger : void 0,
                  children: /* @__PURE__ */ k(kt, { isPlain: !0, children: [
                    /* @__PURE__ */ t(
                      It,
                      {
                        placeholder: o,
                        value: c === ue.typeahead && C.value ? te(P) ? P.find(
                          (x) => x.key === (Array.isArray(C.value) ? C.value[0] : C.value)
                        )?.value : C.value : g,
                        onClick: () => R(!y),
                        onChange: (x, L) => {
                          f(L), d?.(L);
                        },
                        onKeyDown: (x) => j(x, C),
                        autoComplete: "off",
                        innerRef: T,
                        role: "combobox",
                        isExpanded: y,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === ue.typeaheadMulti && Array.isArray(C.value) && /* @__PURE__ */ t(Ze, { "aria-label": "Current selections", children: C.value.map(
                          (x, L) => /* @__PURE__ */ t(
                            et,
                            {
                              onClick: (D) => {
                                D.stopPropagation(), C.onChange(
                                  C.value.filter(
                                    (O) => O !== ie(x)
                                  )
                                );
                              },
                              children: te(P) ? [
                                ...P,
                                ...I
                              ].find((D) => x === D.key)?.value : ee(x)
                            },
                            L
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ t(wt, { children: (!!g || C.value) && /* @__PURE__ */ t(
                      q,
                      {
                        variant: "plain",
                        onClick: () => {
                          f(""), C.onChange(F ? [] : ""), T.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ t(Ot, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (w, x) => {
                w?.stopPropagation();
                const L = x?.toString();
                F && Array.isArray(C.value) ? (f(""), H(L || "", C)) : (C.onChange(Array.isArray(C.value) ? [L] : L), R(!1));
              },
              isOpen: y,
              children: /* @__PURE__ */ t(Ae, { children: K.map((w, x) => /* @__PURE__ */ t(
                Qe,
                {
                  value: ie(w),
                  isFocused: b === x,
                  isActive: C.value.includes(ee(w)),
                  description: !fe(w) && "description" in w ? w.description : void 0,
                  children: ee(w)
                },
                ie(w)
              )) })
            }
          )
        }
      )
    }
  );
};
var ue = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(ue || {});
const te = (e) => typeof e[0] != "string", fe = (e) => typeof e == "string", ie = (e) => fe(e) ? e : e.key, Hr = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t($r, { ...n }) : /* @__PURE__ */ t(Kr, { ...n, variant: e }), He = (e) => e && typeof e == "string" ? e.includes("${") : !1, je = (e) => e.substring(2, e.length - 1), re = (e, n, r, a) => {
  const l = n || r, i = He(l) ? je(l) : l, s = a ? `${a}.${i}` : i;
  return e(s || "");
}, Ge = (e, n) => re(e, n.displayName, n.name), jr = ["username", "firstName", "lastName", "email"], Ut = (e) => e && jr.includes(e), Q = (e) => `${Ut(e) ? "" : "attributes."}${e?.replaceAll(
  ".",
  "🍺"
)}`, za = (e) => e.replaceAll(".", "🍺"), Gr = (e) => e.replaceAll("🍺", ".");
function Ja(e, n, r) {
  (e.responseData.errors !== void 0 ? e.responseData.errors : [e.responseData]).forEach((a) => {
    const l = Object.assign(
      {},
      a.params?.map((i) => He(i) ? r(je(i)) : i)
    );
    n(Q(a.field), {
      message: r(
        He(a.errorMessage) ? je(a.errorMessage) : a.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...l,
          defaultValue: a.errorMessage || a.field
        }
      ),
      type: "server"
    });
  });
}
function Fe({
  required: e
}) {
  return e;
}
function Ya(e) {
  if (typeof e != "object" || e === null || !("responseData" in e))
    return !1;
  const { responseData: n } = e;
  return ut(n) ? !0 : typeof n != "object" || n === null || !("errors" in n) || !Array.isArray(n.errors) ? !1 : n.errors.every(ut);
}
function ut(e) {
  return !(typeof e != "object" || e === null || !("field" in e) || typeof e.field != "string" || !("errorMessage" in e) || typeof e.errorMessage != "string");
}
const Qa = ({
  labelOn: e,
  stringify: n,
  defaultValue: r,
  labelIcon: a,
  ...l
}) => {
  const s = r ?? (n ? "false" : !1), { control: o } = Re();
  return /* @__PURE__ */ t(
    Y,
    {
      hasNoPaddingTop: !0,
      name: l.name,
      isRequired: l.rules?.required === !0,
      label: l.label,
      labelIcon: a,
      children: /* @__PURE__ */ t(
        oe,
        {
          control: o,
          name: l.name,
          defaultValue: s,
          render: ({ field: { onChange: d, value: c } }) => /* @__PURE__ */ t(
            cn,
            {
              ...l,
              id: l.name,
              "data-testid": Gr(l.name),
              label: e,
              "aria-label": l.label,
              isChecked: n ? c === "true" : c,
              onChange: (u, h) => {
                const m = n ? h.toString() : h;
                l.onChange?.(u, h), d(m);
              }
            }
          )
        }
      )
    }
  );
}, Xa = (e) => {
  const n = !!e.rules?.required, r = e.defaultValue ?? "", { field: a, fieldState: l } = De({
    ...e,
    defaultValue: r
  });
  return /* @__PURE__ */ t(
    Y,
    {
      isRequired: n,
      label: e.label,
      labelIcon: e.labelIcon,
      name: e.name,
      error: l.error,
      children: /* @__PURE__ */ t(
        St,
        {
          isRequired: n,
          id: e.name,
          "data-testid": e.name,
          validated: l.error ? W.error : W.default,
          isDisabled: e.isDisabled,
          ...e,
          ...a
        }
      )
    }
  );
}, Za = (e) => {
  const { labelIcon: n, helperText: r, ...a } = e, l = !!ce(e.rules?.required), i = e.defaultValue ?? "", { field: s, fieldState: o } = De({
    ...e,
    defaultValue: i
  });
  return /* @__PURE__ */ k(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: l,
      error: o.error,
      children: [
        /* @__PURE__ */ t(
          Te,
          {
            isRequired: l,
            id: e.name,
            "data-testid": e["data-testid"] || e.name,
            validated: o.error ? W.error : W.default,
            isDisabled: e.isDisabled,
            ...a,
            ...s
          }
        ),
        r && /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(Je, { children: /* @__PURE__ */ t(Ye, { children: r }) }) })
      ]
    }
  );
}, Wr = St, el = (e) => {
  const { labelIcon: n, ...r } = e, a = !!ce(e.rules?.required), l = e.defaultValue ?? "", { t: i } = U(), [s, o] = A(""), { field: d, fieldState: c } = De({
    ...e,
    defaultValue: l
  });
  return /* @__PURE__ */ t(
    Y,
    {
      name: e.name,
      label: e.label,
      labelIcon: n,
      isRequired: a,
      error: c.error,
      children: /* @__PURE__ */ t(
        dn,
        {
          isRequired: a,
          "data-testid": e["data-testid"] || e.name,
          filename: s,
          browseButtonText: i("browse"),
          validated: c.error ? W.error : W.default,
          hideDefaultPreview: !0,
          isDisabled: e.isDisabled,
          type: "text",
          onFileInputChange: (u, h) => {
            d.onChange(h), o(h.name);
          },
          onClearClick: () => {
            d.onChange(null), o("");
          },
          ...r,
          ...d
        }
      )
    }
  );
}, tl = ({ icon: e }) => {
  const n = zr(e);
  return /* @__PURE__ */ t(qe, { size: "lg", children: /* @__PURE__ */ t(n, { alt: e }) });
};
function zr(e) {
  switch (e) {
    case "github":
      return sr;
    case "facebook":
      return ir;
    case "gitlab":
      return lr;
    case "google":
      return ar;
    case "linkedin":
    case "linkedin-openid-connect":
      return rr;
    case "openshift-v4":
      return nr;
    case "stackoverflow":
      return tr;
    case "twitter":
      return er;
    case "microsoft":
      return Zn;
    case "bitbucket":
      return Xn;
    case "instagram":
      return Qn;
    case "paypal":
      return Yn;
    default:
      return Jn;
  }
}
const Jr = "_title_180i0_2", Yr = {
  title: Jr
}, $t = ({
  id: e,
  title: n,
  headingLevel: r = "h1",
  size: a = "xl",
  ...l
}) => /* @__PURE__ */ t(
  un,
  {
    headingLevel: r,
    size: a,
    className: Yr.title,
    id: e,
    tabIndex: 0,
    ...l,
    children: n
  }
), Qr = ({
  title: e,
  children: n,
  scrollId: r,
  className: a
}) => {
  const l = At();
  return /* @__PURE__ */ k(hn, { id: l, className: a, isFlat: !0, children: [
    /* @__PURE__ */ t(fn, { className: "kc-form-panel__header", children: /* @__PURE__ */ t(mn, { tabIndex: 0, children: /* @__PURE__ */ t($t, { id: r, title: e }) }) }),
    /* @__PURE__ */ t(pn, { className: "kc-form-panel__body", children: n })
  ] });
}, Xr = (e) => {
  const { title: n, children: r, scrollId: a, ...l } = e;
  return /* @__PURE__ */ t("section", { ...l, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ k(J, { children: [
    /* @__PURE__ */ t($t, { id: a, title: n }),
    r
  ] }) });
}, Zr = "_panel_1cdve_1", ea = "_sticky_1cdve_5", ht = {
  panel: Zr,
  sticky: ea
}, ta = "kc-main-content-page-container", Ne = (e) => e.replace(/\s+/g, "-"), na = ({
  label: e,
  sections: n,
  borders: r = !1,
  ...a
}) => {
  const l = $(
    () => n.filter(({ isHidden: o }) => !o),
    [n]
  ), [i, s] = A(0);
  return ae(() => {
    const o = document.getElementById(ta);
    if (!o) return;
    const d = 100, c = () => {
      const u = o.scrollTop + d;
      let h = 0;
      l.forEach(({ title: m }, p) => {
        const y = Ne(m.toLowerCase()), R = document.getElementById(y);
        R && u >= R.offsetTop && (h = p);
      }), s(h);
    };
    return c(), o.addEventListener("scroll", c), () => o.removeEventListener("scroll", c);
  }, [l]), /* @__PURE__ */ k(gn, { hasGutter: !0, ...a, children: [
    /* @__PURE__ */ t(st, { md: 8, sm: 12, children: l.map(({ title: o, panel: d }) => {
      const c = Ne(o.toLowerCase());
      return /* @__PURE__ */ t(Rt, { children: r ? /* @__PURE__ */ t(
        Qr,
        {
          scrollId: c,
          title: o,
          className: ht.panel,
          children: d
        }
      ) : /* @__PURE__ */ t(Xr, { scrollId: c, title: o, children: d }) }, o);
    }) }),
    /* @__PURE__ */ t(st, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ t(yn, { className: ht.sticky, children: /* @__PURE__ */ t(vn, { isVertical: !0, label: e, children: l.map(({ title: o }, d) => {
      const c = Ne(o.toLowerCase());
      return /* @__PURE__ */ t(
        bn,
        {
          isActive: i === d,
          onClick: () => {
            const u = document.getElementById(c);
            u && u.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          },
          "data-testid": `jump-link-${c}`,
          children: o
        },
        o
      );
    }) }) }) })
  ] });
}, ra = (e, n, r) => (e.isValid || r) && (e.isDirty || n) && !e.isLoading && !e.isValidating && !e.isSubmitting, nl = ({
  formState: e,
  isDisabled: n = !1,
  allowInvalid: r = !1,
  allowNonDirty: a = !1,
  children: l,
  ...i
}) => /* @__PURE__ */ t(
  q,
  {
    variant: "primary",
    isDisabled: !ra(e, a, r) || n,
    ...i,
    type: "submit",
    children: l
  }
), aa = (e) => {
  try {
    return new Intl.DisplayNames([e], { type: "language" }).of(e);
  } catch {
    return e;
  }
}, la = ({
  t: e,
  form: n,
  supportedLocales: r,
  currentLocale: a
}) => {
  const l = $(
    () => r.map((i) => ({
      key: i,
      value: e(`locale_${i}`, aa(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, a)),
    [r, a, e]
  );
  return l.length ? /* @__PURE__ */ t(fr, { ...n, children: /* @__PURE__ */ t(
    Hr,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: e("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: e("defaultLocale") }, ...l],
      variant: l.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, pe = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  children: l
}) => {
  const i = re(
    e,
    r.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = n, o = a?.(r), d = _(s, Q(r.name));
  return /* @__PURE__ */ k(
    Ct,
    {
      label: Ge(e, r) || "",
      fieldId: r.name,
      isRequired: Fe(r),
      labelIcon: i ? /* @__PURE__ */ t(_t, { helpText: i, fieldLabelId: r.name }) : void 0,
      children: [
        o ? /* @__PURE__ */ k(xe, { children: [
          l,
          o
        ] }) : l,
        d && /* @__PURE__ */ t(
          Nt,
          {
            "data-testid": `${r.name}-helper`,
            message: d.message
          }
        )
      ]
    },
    r.name
  );
}, ia = ({
  t: e,
  form: n,
  attribute: r,
  renderer: a,
  ...l
}) => /* @__PURE__ */ t(pe, { t: e, form: n, attribute: r, renderer: a, children: /* @__PURE__ */ t(
  sa,
  {
    t: e,
    form: n,
    "aria-label": Ge(e, r),
    name: Q(r.name),
    defaultValue: [r.defaultValue || ""],
    addButtonLabel: e("addMultivaluedLabel", {
      fieldLabel: Ge(e, r)
    }),
    isDisabled: r.readOnly,
    ...l
  }
) }), sa = ({
  t: e,
  name: n,
  inputType: r,
  form: a,
  addButtonLabel: l,
  isDisabled: i = !1,
  defaultValue: s,
  id: o,
  ...d
}) => {
  const { register: c, setValue: u, control: h } = a, m = mr({
    name: n,
    control: h,
    defaultValue: s || ""
  }), p = $(() => Array.isArray(m) && m.length !== 0 ? m : s || [""], [m]), y = (E) => {
    f([...p.slice(0, E), ...p.slice(E + 1)]);
  }, R = () => {
    f([...p, ""]);
  }, g = (E, I) => {
    f([...p.slice(0, E), I, ...p.slice(E + 1)]);
  }, f = (E) => {
    const I = E.flatMap((v) => v);
    u(n, I, {
      shouldDirty: !0
    });
  }, b = r.startsWith("html") ? r.substring(6) : "text";
  return ae(() => {
    c(n);
  }, [c]), /* @__PURE__ */ t("div", { id: o, children: p.map((E, I) => /* @__PURE__ */ k(Rt, { children: [
    /* @__PURE__ */ k(xe, { children: [
      /* @__PURE__ */ t(Ue, { isFill: !0, children: /* @__PURE__ */ t(
        Te,
        {
          "data-testid": n + I,
          onChange: (v, T) => g(I, T),
          name: `${n}.${I}.value`,
          value: E,
          isDisabled: i,
          type: b,
          ...d
        }
      ) }),
      /* @__PURE__ */ t(Ue, { children: /* @__PURE__ */ t(
        q,
        {
          "data-testid": "remove" + I,
          variant: we.link,
          onClick: () => y(I),
          tabIndex: -1,
          "aria-label": e("remove"),
          isDisabled: p.length === 1 || i,
          children: /* @__PURE__ */ t(or, {})
        }
      ) })
    ] }),
    I === p.length - 1 && /* @__PURE__ */ k(
      q,
      {
        variant: we.link,
        onClick: R,
        tabIndex: -1,
        "aria-label": e("add"),
        "data-testid": "addValue",
        isDisabled: !E || i,
        children: [
          /* @__PURE__ */ t(Pt, {}),
          " ",
          e(l || "add")
        ]
      }
    )
  ] }, I)) });
}, ft = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Fe(a), i = r.startsWith("multiselect"), s = i ? Cn : kn, o = a.validators?.options?.options || [], d = a.annotations?.inputOptionLabels || {}, c = a.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: Q(a.name),
      control: n.control,
      defaultValue: a.defaultValue,
      render: ({ field: u }) => /* @__PURE__ */ t(J, { children: o.map((h) => /* @__PURE__ */ t(
        s,
        {
          id: h,
          "data-testid": h,
          label: re(e.t, d[h], h, c),
          value: h,
          isChecked: u.value?.includes(h),
          onChange: () => {
            i ? u.value?.includes(h) ? u.onChange(
              u.value?.filter((m) => m !== h)
            ) : u.onChange([...u.value || [], h]) : u.onChange([h]);
          },
          readOnly: a.readOnly,
          isRequired: l
        },
        h
      )) })
    }
  ) });
}, oa = ({
  toggleId: e,
  onToggle: n,
  onSelect: r,
  selections: a,
  isOpen: l,
  menuAppendTo: i,
  direction: s,
  width: o,
  maxHeight: d,
  toggleIcon: c,
  className: u,
  isDisabled: h,
  children: m,
  ...p
}) => {
  const [y, R] = A(!1), g = ne(), f = () => {
    R(!y), n(!y);
  }, b = () => i === "parent" && g.current?.parentElement || "inline", E = Dt.toArray(
    m
  );
  return /* @__PURE__ */ t(
    Ee,
    {
      ref: g,
      maxMenuHeight: Se(d),
      isScrollable: !0,
      popperProps: {
        appendTo: b(),
        direction: s,
        width: Se(o)
      },
      ...p,
      onClick: f,
      onOpenChange: (I) => {
        I !== y && f();
      },
      selected: a,
      onSelect: (I, v) => {
        r?.(v || ""), f();
      },
      toggle: (I) => /* @__PURE__ */ t(
        me,
        {
          id: e,
          ref: I,
          className: u,
          onClick: f,
          isExpanded: l,
          "aria-label": p["aria-label"],
          icon: c,
          isDisabled: h,
          isFullWidth: !0,
          children: E.find((v) => v.props.value === a)?.props.children || a || p["aria-label"]
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Ae, { children: m })
    }
  );
}, ca = ({
  toggleId: e,
  onSelect: n,
  onToggle: r,
  onFilter: a,
  onClear: l,
  variant: i,
  validated: s,
  placeholderText: o,
  maxHeight: d,
  width: c,
  toggleIcon: u,
  direction: h,
  selections: m,
  typeAheadAriaLabel: p,
  chipGroupComponent: y,
  chipGroupProps: R,
  footer: g,
  isDisabled: f,
  children: b,
  ...E
}) => {
  const [I, v] = A(""), [T, B] = A(!1), [F, P] = A(0), K = ne(), H = Dt.toArray(
    b
  ), j = a || !T || !I ? H : H.filter((D) => {
    const { children: O, value: V } = D.props;
    return (typeof O == "string" ? O : String(V ?? "")).toLowerCase().includes(I.toLowerCase());
  }), C = i === se.typeahead && !T && m ? m : I, w = () => {
    B(!1), v(""), P(0), a?.("");
  }, x = () => {
    r(!E.isOpen);
  }, L = (D) => {
    const O = j.at(F);
    switch (r(!0), D.key) {
      case "Enter": {
        if (D.preventDefault(), !O) break;
        n?.(O.props.value), r(!1), w();
        break;
      }
      case "Escape": {
        r(!1), w();
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        if (D.preventDefault(), j.length === 0) break;
        let V = 0;
        D.key === "ArrowUp" && (F === 0 ? V = j.length - 1 : V = F - 1), D.key === "ArrowDown" && (F === j.length - 1 ? V = 0 : V = F + 1), P(V);
        break;
      }
    }
  };
  return /* @__PURE__ */ k(
    Ee,
    {
      ...E,
      onClick: x,
      onOpenChange: (D) => {
        r(D), D || w();
      },
      onSelect: (D, O) => {
        n?.(O || ""), w();
      },
      maxMenuHeight: Se(d),
      popperProps: { direction: h, width: Se(c) },
      toggle: (D) => /* @__PURE__ */ t(
        me,
        {
          ref: D,
          id: e,
          variant: "typeahead",
          onClick: () => r(!0),
          icon: u,
          isDisabled: f,
          isExpanded: E.isOpen,
          isFullWidth: !0,
          status: s === "error" ? Xe.danger : void 0,
          children: /* @__PURE__ */ k(kt, { isPlain: !0, children: [
            /* @__PURE__ */ t(
              It,
              {
                placeholder: o,
                value: C,
                onClick: x,
                onChange: (O, V) => {
                  B(!0), v(V), P(0), a?.(V);
                },
                onKeyDown: (O) => L(O),
                autoComplete: "off",
                innerRef: K,
                role: "combobox",
                isExpanded: E.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": p,
                children: i === se.typeaheadMulti && Array.isArray(m) && (y || /* @__PURE__ */ t(Ze, { ...R, children: m.map((O, V) => /* @__PURE__ */ t(
                  et,
                  {
                    onClick: (ge) => {
                      ge.stopPropagation(), n?.(O);
                    },
                    children: O
                  },
                  V
                )) }))
              }
            ),
            /* @__PURE__ */ t(wt, { children: !!C && /* @__PURE__ */ t(
              q,
              {
                variant: "plain",
                onClick: () => {
                  l ? l() : n?.(""), w(), K.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ t(Ot, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ t(Ae, { children: j }),
        g && /* @__PURE__ */ t(In, { children: g })
      ]
    }
  );
};
var se = /* @__PURE__ */ ((e) => (e.single = "single", e.typeahead = "typeahead", e.typeaheadMulti = "typeaheadMulti", e))(se || {});
const Se = (e) => typeof e == "number" ? e + "px" : e, da = ({
  variant: e = "single",
  ...n
}) => e === "single" ? /* @__PURE__ */ t(oa, { ...n }) : /* @__PURE__ */ t(ca, { ...n, variant: e }), mt = (e) => {
  const { t: n, form: r, inputType: a, attribute: l } = e, [i, s] = A(!1), [o, d] = A(""), c = a === "multiselect", u = (g, f) => {
    c ? f.value?.includes(g) ? f.onChange(f.value.filter((b) => b !== g)) : Array.isArray(f.value) ? f.onChange([...f.value, g]) : f.onChange([g]) : f.onChange(g === f.value ? "" : g);
  }, h = l.validators?.options?.options || [], m = l.annotations?.inputOptionLabels || {}, p = l.annotations?.inputOptionLabelsI18nPrefix, y = (g) => re(e.t, m[g], g, p), R = (g) => h.filter(
    (f) => y(f).toLowerCase().includes(o.toLowerCase())
  ).map((f) => /* @__PURE__ */ t(
    Qe,
    {
      selected: Array.isArray(g) ? g.includes(f) : g === f,
      value: f,
      children: y(f)
    },
    f
  ));
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    oe,
    {
      name: Q(l.name),
      defaultValue: l.defaultValue,
      control: r.control,
      render: ({ field: g }) => /* @__PURE__ */ t(
        da,
        {
          toggleId: l.name,
          onToggle: (f) => s(f),
          onClear: () => u("", g),
          onSelect: (f) => {
            const b = f.toString();
            u(b, g), Array.isArray(g.value) || s(!1);
          },
          selections: c && Array.isArray(g.value) ? g.value.map((f) => y(f)) : y(g.value),
          variant: c ? se.typeaheadMulti : h.length >= 10 ? se.typeahead : se.single,
          "aria-label": n("selectOne"),
          isOpen: i,
          isDisabled: l.readOnly,
          onFilter: (f) => (d(f), R(g.value)),
          children: R(g.value)
        }
      )
    }
  ) });
}, ua = (e) => {
  const { form: n, attribute: r } = e, a = Fe(r);
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    Wr,
    {
      id: r.name,
      "data-testid": r.name,
      ...n.register(Q(r.name)),
      cols: r.annotations?.inputTypeCols,
      rows: r.annotations?.inputTypeRows,
      readOnly: r.readOnly,
      isRequired: a,
      defaultValue: r.defaultValue
    }
  ) });
}, G = (e) => {
  const { form: n, inputType: r, attribute: a } = e, l = Fe(a), i = r.startsWith("html") ? r.substring(6) : "text";
  return /* @__PURE__ */ t(pe, { ...e, children: /* @__PURE__ */ t(
    Te,
    {
      id: a.name,
      "data-testid": a.name,
      type: i,
      placeholder: a.readOnly ? "" : re(
        e.t,
        a.annotations?.inputTypePlaceholder,
        "",
        a.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: a.readOnly,
      isRequired: l,
      defaultValue: a.defaultValue,
      ...n.register(Q(a.name))
    }
  ) });
}, We = {
  text: G,
  textarea: ua,
  select: mt,
  "select-radiobuttons": ft,
  multiselect: mt,
  "multiselect-checkboxes": ft,
  "html5-email": G,
  "html5-tel": G,
  "html5-url": G,
  "html5-number": G,
  "html5-range": G,
  "html5-datetime-local": G,
  "html5-date": G,
  "html5-month": G,
  "html5-time": G,
  "multi-input": ia
}, rl = ({
  t: e,
  form: n,
  userProfileMetadata: r,
  supportedLocales: a,
  currentLocale: l,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const o = $(() => {
    if (!r.attributes)
      return [];
    const d = i ? r.attributes.filter(({ readOnly: c }) => !c) : r.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...r.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: d.filter(
        (u) => u.group === c.name
      )
    }));
  }, [
    i,
    r.groups,
    r.attributes
  ]);
  return o.length === 0 ? null : /* @__PURE__ */ t(
    na,
    {
      label: e("jumpToSection"),
      sections: o.filter((d) => d.attributes.length > 0).map(({ group: d, attributes: c }) => ({
        title: re(e, d.displayHeader, d.name) || e("general"),
        panel: /* @__PURE__ */ k("div", { className: "pf-v5-c-form", children: [
          d.displayDescription && /* @__PURE__ */ t(ke, { className: "pf-v5-u-pb-lg", children: re(e, d.displayDescription, "") }),
          c.map((u) => /* @__PURE__ */ t(
            ha,
            {
              t: e,
              form: n,
              supportedLocales: a,
              currentLocale: l,
              renderer: s,
              attribute: u
            },
            u.name
          ))
        ] })
      }))
    }
  );
}, ha = ({
  t: e,
  form: n,
  renderer: r,
  supportedLocales: a,
  currentLocale: l,
  attribute: i
}) => {
  const s = n.watch(
    Q(i.name)
  ), o = $(() => ma(i), [i]), d = i.multivalued || ga(s) && i.annotations?.inputType === void 0 ? We["multi-input"] : We[o];
  return i.name === "locale" ? /* @__PURE__ */ t(
    la,
    {
      form: n,
      supportedLocales: a,
      currentLocale: l,
      t: e,
      attribute: i
    }
  ) : /* @__PURE__ */ t(
    d,
    {
      t: e,
      form: n,
      inputType: o,
      attribute: i,
      renderer: r
    }
  );
}, fa = "text";
function ma(e) {
  if (Ut(e.name))
    return "text";
  const n = e.annotations?.inputType;
  return pa(n) ? n : fa;
}
const pa = (e) => typeof e == "string" && e in We, ga = (e) => Array.isArray(e) && e.length > 1, ya = ({
  className: e = "",
  border: n,
  size: r = "md"
}) => /* @__PURE__ */ k(
  "svg",
  {
    className: yr(
      be.avatar,
      be.modifiers[r],
      n === "light" && be.modifiers.light,
      n === "dark" && be.modifiers.dark,
      e
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ t(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ t("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ t(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ t("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ k("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), pt = ({
  isKebab: e = !1,
  title: n,
  dropDownItems: r,
  ...a
}) => {
  const [l, i] = A(!1);
  return /* @__PURE__ */ t(
    wn,
    {
      ...a,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ t(
        me,
        {
          "data-testid": `${a["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!l),
          isExpanded: l,
          variant: e ? "plain" : "default",
          children: e ? /* @__PURE__ */ t(cr, {}) : n
        }
      ),
      isOpen: l,
      children: /* @__PURE__ */ t(Sn, { children: r })
    }
  );
};
function va(e, n) {
  if (!e)
    return n("unknownUser");
  const r = e.given_name, a = e.family_name, l = e.preferred_username;
  return r && a ? n("fullName", { givenName: r, familyName: a }) : r || a || l || n("unknownUser");
}
const al = ({
  keycloak: e,
  brand: { src: n, alt: r, className: a, ...l },
  avatar: i,
  features: {
    hasLogout: s = !0,
    hasManageAccount: o = !0,
    hasUsername: d = !0
  } = {},
  kebabDropdownItems: c,
  dropdownItems: u = [],
  toolbarItems: h,
  toolbar: m,
  ...p
}) => {
  const { t: y } = U(), R = [];
  o && R.push(
    /* @__PURE__ */ t(
      ot,
      {
        onClick: () => e.accountManagement(),
        children: y("manageAccount")
      },
      "manageAccount"
    )
  ), s && R.push(
    /* @__PURE__ */ t(ot, { onClick: () => e.logout(), children: y("signOut") }, "signOut")
  );
  const g = e.idTokenParsed?.picture;
  return /* @__PURE__ */ k(xn, { ...p, children: [
    /* @__PURE__ */ t(Tn, { children: /* @__PURE__ */ t(
      En,
      {
        "data-testid": "nav-toggle",
        variant: "plain",
        "aria-label": y("navigation"),
        children: /* @__PURE__ */ t(dr, {})
      }
    ) }),
    /* @__PURE__ */ t(An, { ...l, children: /* @__PURE__ */ t("img", { src: n, alt: r, className: a }) }),
    /* @__PURE__ */ k(Rn, { children: [
      m,
      /* @__PURE__ */ t(Ie, { children: /* @__PURE__ */ k($e, { children: [
        h?.map((f, b) => /* @__PURE__ */ t(z, { align: { default: "alignRight" }, children: f }, b)),
        /* @__PURE__ */ t(
          z,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            children: /* @__PURE__ */ t(
              pt,
              {
                "data-testid": "options",
                dropDownItems: [...u, R],
                title: d ? va(e.idTokenParsed, y) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          z,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ t(
              pt,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...c || u,
                  R
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          z,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: g || i?.src ? /* @__PURE__ */ t(Dn, { src: g, alt: y("avatar"), ...i }) : /* @__PURE__ */ t(ya, { ...i })
          }
        )
      ] }) })
    ] })
  ] });
}, Kt = tt("ErrorBoundaryContext", void 0), Ht = () => nt(Kt);
class ll extends $n {
  state = {};
  static getDerivedStateFromError = (n) => ({ error: n });
  showBoundary = (n) => {
    this.setState({ error: n });
  };
  render() {
    return /* @__PURE__ */ t(
      Kt.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const il = ({ children: e, fallback: n }) => {
  const { error: r } = Ht();
  return r ? /* @__PURE__ */ t(n, { error: r }) : e;
};
function ba(e, n, r) {
  const { showBoundary: a } = Ht();
  ae(() => {
    const l = new AbortController(), { signal: i } = l;
    return e().then((s) => {
      i.aborted || n(s);
    }).catch((s) => {
      console.error(s), i.aborted || a(s);
    }), () => l.abort();
  }, r);
}
const Ca = () => {
  const { t: e } = U();
  return /* @__PURE__ */ t(Fn, { children: /* @__PURE__ */ t(bt, { "aria-label": e("spinnerLoading") }) });
}, ka = ({
  message: e,
  instructions: n,
  onPrimaryAction: r,
  hasIcon: a = !0,
  isSearchVariant: l,
  primaryActionText: i,
  secondaryActions: s,
  icon: o,
  isDisabled: d = !1,
  children: c
}) => /* @__PURE__ */ k(On, { "data-testid": "empty-state", variant: "lg", children: [
  a && l ? /* @__PURE__ */ t(ct, { icon: ur }) : a && /* @__PURE__ */ t(ct, { icon: o || Pt }),
  /* @__PURE__ */ t(Pn, { titleText: e, headingLevel: "h1" }),
  /* @__PURE__ */ t(Vn, { children: n }),
  /* @__PURE__ */ k(Ln, { children: [
    i && /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${e.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: r,
        isDisabled: d,
        children: i
      }
    ),
    c,
    s && /* @__PURE__ */ t(Mn, { children: s.map((u) => /* @__PURE__ */ t(
      q,
      {
        "data-testid": `${u.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: u.type || we.secondary,
        onClick: u.onClick,
        isDisabled: d,
        children: u.text
      },
      u.text
    )) })
  ] })
] }), Ia = ({
  toolbarItem: e,
  subToolbar: n,
  toolbarItemFooter: r,
  children: a,
  searchTypeComponent: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o
}) => {
  const { t: d } = U(), [c, u] = A(""), h = (p) => {
    u(p.trim()), o?.(p.trim());
  }, m = (p) => {
    p.key === "Enter" && h(c);
  };
  return /* @__PURE__ */ k(J, { children: [
    /* @__PURE__ */ t(Ie, { "data-testid": "table-toolbar", children: /* @__PURE__ */ k($e, { children: [
      i && /* @__PURE__ */ t(z, { children: /* @__PURE__ */ k(xe, { "data-testid": i, children: [
        l,
        s && /* @__PURE__ */ t(
          Bn,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": d("search"),
            value: c,
            onChange: (p, y) => {
              u(y);
            },
            onSearch: () => h(c),
            onKeyDown: m,
            onClear: () => h("")
          }
        )
      ] }) }),
      e
    ] }) }),
    n && /* @__PURE__ */ t(Ie, { children: /* @__PURE__ */ t($e, { children: n }) }),
    /* @__PURE__ */ t(Nn, {}),
    a,
    /* @__PURE__ */ t(Ie, { children: r })
  ] });
}, gt = ({
  id: e,
  variant: n = "top",
  count: r,
  first: a,
  max: l,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: o
}) => {
  const { t: d } = U(), c = Math.round(a / l);
  return /* @__PURE__ */ t(
    _n,
    {
      widgetId: e,
      titles: {
        paginationAriaLabel: `${d("pagination")} ${n} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: u,
        lastIndex: h
      }) => /* @__PURE__ */ k("b", { children: [
        u,
        " - ",
        h
      ] }),
      itemCount: r + c * l,
      page: c + 1,
      perPage: l,
      onNextClick: (u, h) => i((h - 1) * l),
      onPreviousClick: (u, h) => s((h - 1) * l),
      onPerPageSelect: (u, h, m) => o(m - 1, h),
      variant: n
    }
  );
}, wa = ({
  count: e,
  searchTypeComponent: n,
  toolbarItem: r,
  subToolbar: a,
  children: l,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: o,
  ...d
}) => /* @__PURE__ */ t(
  Ia,
  {
    searchTypeComponent: n,
    toolbarItem: /* @__PURE__ */ k(J, { children: [
      r,
      /* @__PURE__ */ t(z, { variant: "pagination", children: /* @__PURE__ */ t(gt, { count: e, ...d }) })
    ] }),
    subToolbar: a,
    toolbarItemFooter: e !== 0 ? /* @__PURE__ */ t(z, { variant: "pagination", children: /* @__PURE__ */ t(gt, { count: e, variant: "bottom", ...d }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: o,
    children: l
  }
), jt = (e) => !!e && e.title !== void 0, yt = ({
  row: e,
  index: n,
  actions: r,
  actionResolver: a
}) => {
  const l = r || a?.(e, {});
  return /* @__PURE__ */ k(J, { children: [
    e.cells.map((i, s) => /* @__PURE__ */ t(le, { children: jt(i) ? i.title : i }, `cell-${s}`)),
    l && l.length > 0 && !e.disableActions && /* @__PURE__ */ t(le, { isActionCell: !0, children: /* @__PURE__ */ t(Ir, { items: l, extraData: { rowIndex: n } }) })
  ] });
}, Sa = ({ row: e }) => e.cells.map((n, r) => /* @__PURE__ */ t("div", { children: jt(n) ? n.title : n }, `cell-${r}`));
function xa({
  columns: e,
  rows: n,
  actions: r,
  actionResolver: a,
  ariaLabelKey: l,
  selected: i,
  onSelect: s,
  onCollapse: o,
  canSelectAll: d,
  canSelect: c,
  isNotCompact: u,
  isRadio: h,
  ...m
}) {
  const { t: p } = U(), [y, R] = A(i || []), [g, f] = A([]), b = $(
    () => pr(
      y,
      n.map((v) => v.data),
      "id"
    ),
    [y, n]
  );
  ae(() => {
    if (d) {
      const v = document.getElementsByName("check-all").item(0);
      if (v) {
        const T = v;
        T.indeterminate = b.length < n.length && b.length > 0;
      }
    }
  }, [y, d, n]);
  const E = (v) => {
    R(v), s?.(v);
  }, I = (v, T) => {
    if (h) {
      const B = T ? [n[v].data] : [];
      E(B);
    } else if (v === -1) {
      const B = b.map(
        (F) => _(F, "id")
      );
      E(
        T ? [...y, ...n.map((F) => F.data)] : y.filter(
          (F) => !B.includes(_(F, "id"))
        )
      );
    } else
      E(T ? [...y, n[v].data] : y.filter(
        (B) => _(B, "id") !== n[v].data.id
      ));
  };
  return /* @__PURE__ */ k(
    vr,
    {
      ...m,
      variant: u ? void 0 : br.compact,
      "aria-label": p(l),
      children: [
        /* @__PURE__ */ t(Cr, { children: /* @__PURE__ */ k(Ce, { children: [
          o && /* @__PURE__ */ t(Me, { screenReaderText: p("expandRow") }),
          d && /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: p("selectAll"),
              select: h ? void 0 : {
                onSelect: (v, T) => {
                  I(-1, T);
                },
                isSelected: b.length === n.length
              }
            }
          ),
          e.map((v) => /* @__PURE__ */ t(
            Me,
            {
              screenReaderText: p("expandRow"),
              className: v.transforms?.[0]().className,
              children: p(v.displayKey || v.name)
            },
            v.displayKey || v.name
          ))
        ] }) }),
        o ? n.map((v, T) => /* @__PURE__ */ t(dt, { children: T % 2 === 0 ? /* @__PURE__ */ k(Ce, { children: [
          /* @__PURE__ */ t(
            le,
            {
              expand: n[T + 1].cells.length === 0 ? void 0 : {
                isExpanded: g[T] ?? !1,
                rowIndex: T,
                expandId: "expandable-row-",
                onToggle: (B, F, P) => {
                  o(P, F);
                  const K = [...g];
                  K[T] = P, f(K);
                }
              }
            }
          ),
          /* @__PURE__ */ t(
            yt,
            {
              row: v,
              index: T,
              actions: r,
              actionResolver: a
            }
          )
        ] }) : /* @__PURE__ */ k(Ce, { isExpanded: g[T - 1] ?? !1, children: [
          /* @__PURE__ */ t(le, {}),
          /* @__PURE__ */ t(le, { colSpan: e.length, children: /* @__PURE__ */ t(kr, { children: /* @__PURE__ */ t(Sa, { row: v }) }) })
        ] }) }, T)) : /* @__PURE__ */ t(dt, { children: n.map((v, T) => /* @__PURE__ */ k(Ce, { isExpanded: g[T], children: [
          c && /* @__PURE__ */ t(
            le,
            {
              select: {
                rowIndex: T,
                onSelect: (B, F, P) => {
                  I(P, F);
                },
                isSelected: !!y.find(
                  (B) => _(B, "id") === v.data.id
                ),
                variant: h ? "radio" : "checkbox",
                isDisabled: v.disableSelection
              }
            }
          ),
          /* @__PURE__ */ t(
            yt,
            {
              row: v,
              index: T,
              actions: r,
              actionResolver: a
            }
          )
        ] }, T)) })
      ]
    }
  );
}
function Ta({
  ariaLabelKey: e,
  searchPlaceholderKey: n,
  isPaginated: r = !1,
  onSelect: a,
  canSelectAll: l = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: o,
  isRowDisabled: d,
  loader: c,
  columns: u,
  actions: h,
  actionResolver: m,
  searchTypeComponent: p,
  toolbarItem: y,
  subToolbar: R,
  emptyState: g,
  icon: f,
  isSearching: b = !1,
  ...E
}) {
  const { t: I } = U(), [v, T] = A([]), [B, F] = A(), [P, K] = A(), [H, j] = A(!1), [C, w] = Mt(
    localStorage,
    "pageSize",
    10
  ), [x, L] = A(C), [D, O] = A(0), [V, ge] = A(""), [Oe, Gt] = A(0), Wt = ne(), rt = () => Gt(Oe + 1), zt = At(), Pe = (S) => {
    S !== V && (O(0), ge(S));
  }, at = (S, M) => S.map((N) => {
    if ("cellFormatters" in N) {
      const Z = _(M, N.name);
      return N.cellFormatters?.reduce((de, ve) => ve(de), Z);
    }
    if (N.cellRenderer) {
      const Z = N.cellRenderer;
      return { title: /* @__PURE__ */ t(Z, { ...M }) };
    }
    return _(M, N.name);
  }), lt = (S) => {
    const M = (N) => o?.[0]?.enabled?.(N);
    return S.map((N, Z) => {
      const de = d ? d(N) : !1, ve = [
        {
          data: N,
          disableSelection: de,
          disableActions: de,
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- lodash get performs dynamic property access at runtime
          selected: !!v.find((Zt) => _(Zt, "id") === _(N, "id")),
          isOpen: M(N) ? !1 : void 0,
          cells: at(u, N)
        }
      ];
      return o && ve.push({
        parent: Z * 2,
        cells: M(N) ? at(o, N) : []
      }), ve;
    }).flat();
  }, Ve = (S) => ["string", "number"].includes(typeof S) ? S.toString() : S instanceof Array ? S.map(Ve).join("") : typeof S == "object" ? Ve(
    Et(S.title) ? S.title.props : Object.values(S)
  ) : "", it = $(
    () => V === "" || r ? void 0 : lt(P || []).filter(
      (S) => S.cells.some(
        (M) => M && Ve(M).toLowerCase().includes(V.toLowerCase())
      )
    ).slice(D, D + x + 1),
    [V, D, x]
  );
  ba(
    async () => (j(!0), await (typeof c == "function" ? c : "loader" in c ? c.loader : async () => c)(D, x + 1, V)),
    (S) => {
      Wt.current = Oe, r || (K(S), S.length > D ? S = S.slice(D, D + x + 1) : O(0));
      const M = lt(S);
      F(M), j(!1);
    },
    [
      Oe,
      D,
      x,
      V,
      typeof c != "function" ? "signal" in c ? c.signal : c : void 0
    ]
  );
  const Jt = () => h && gr(h).map((S, M) => (delete S.onRowClick, S.onClick = async (N, Z) => {
    await h[M].onRowClick(
      (it || B)[Z].data
    ) && (r || Pe(""), rt());
  }, S)), Yt = (S, M) => {
    X[M].isOpen = S, F([...X]);
  }, X = it || B, ye = !X || X.length === 0, Le = V !== "" || b, Qt = o ? x * 2 : x, Xt = o ? (X?.length || 0) / 2 : X?.length || 0;
  return /* @__PURE__ */ k(J, { children: [
    (!ye || Le) && /* @__PURE__ */ k(
      wa,
      {
        id: zt,
        count: Xt,
        first: D,
        max: x,
        onNextClick: O,
        onPreviousClick: O,
        onPerPageSelect: (S, M) => {
          O(S), L(M), w(M);
        },
        inputGroupName: n ? `${e}input` : void 0,
        inputGroupOnEnter: Pe,
        inputGroupPlaceholder: I(n || ""),
        searchTypeComponent: p,
        toolbarItem: /* @__PURE__ */ k(J, { children: [
          y,
          " ",
          /* @__PURE__ */ t(z, { variant: "separator" }),
          " ",
          /* @__PURE__ */ t(z, { children: /* @__PURE__ */ k(q, { variant: "link", onClick: rt, "data-testid": "refresh", children: [
            /* @__PURE__ */ t(hr, {}),
            " ",
            I("refresh")
          ] }) })
        ] }),
        subToolbar: R,
        children: [
          !H && !ye && /* @__PURE__ */ t(
            xa,
            {
              ...E,
              canSelectAll: l,
              canSelect: !!a,
              selected: v,
              onSelect: (S) => {
                T(S), a?.(S);
              },
              onCollapse: o ? Yt : void 0,
              actions: Jt(),
              actionResolver: m,
              rows: X.slice(0, Qt),
              columns: u,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: e
            }
          ),
          !H && ye && Le && /* @__PURE__ */ t(
            ka,
            {
              hasIcon: !0,
              icon: f,
              isSearchVariant: !0,
              message: I("noSearchResults"),
              instructions: I("noSearchResultsInstructions"),
              secondaryActions: b ? [] : [
                {
                  text: I("clearAllFilters"),
                  onClick: () => Pe(""),
                  type: we.link
                }
              ]
            }
          )
        ]
      }
    ),
    H && /* @__PURE__ */ t(Ca, {}),
    !H && ye && !Le && g
  ] });
}
const Ea = ({ link: e, organization: n }) => {
  const { t: r } = U();
  return /* @__PURE__ */ t(Sr, { wrapModifier: "truncate", children: /* @__PURE__ */ k(e, { organization: n, children: [
    n.name,
    !n.enabled && /* @__PURE__ */ t(
      qn,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: r("disabled")
      },
      `${n.id}-disabled`
    )
  ] }) });
}, Aa = (e) => {
  const { t: n } = U();
  return /* @__PURE__ */ t(
    Ze,
    {
      numChips: 2,
      expandedText: n("hide"),
      collapsedText: n("showRemaining"),
      children: e.domains?.map((r) => {
        const a = typeof r == "string" ? r : r.name;
        return /* @__PURE__ */ t(et, { isReadOnly: !0, children: a }, a);
      })
    }
  );
}, sl = ({
  loader: e,
  toolbarItem: n,
  isPaginated: r = !1,
  isSearching: a = !1,
  searchPlaceholderKey: l,
  onSelect: i,
  onDelete: s,
  deleteLabel: o = "delete",
  link: d,
  children: c,
  actions: u,
  membershipTypeRenderer: h
}) => {
  const { t: m } = U();
  return /* @__PURE__ */ t(
    Ta,
    {
      loader: e,
      isPaginated: r,
      isSearching: a,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: l,
      toolbarItem: n,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: [
        ...s ? [{ title: m(o), onRowClick: s }] : [],
        ...u ?? []
      ],
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (p) => /* @__PURE__ */ t(Ea, { link: d, organization: p })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Aa
        },
        {
          name: "description",
          displayKey: "description"
        },
        ...h ? [
          {
            name: "membershipType",
            displayKey: "membershipType",
            transforms: [wr(20)],
            cellRenderer: h
          }
        ] : []
      ],
      emptyState: c
    }
  );
};
export {
  Vr as AlertProvider,
  ja as ContinueCancelModal,
  il as ErrorBoundaryFallback,
  ll as ErrorBoundaryProvider,
  Lr as ErrorPage,
  el as FileUploadControl,
  Nt as FormErrorText,
  Qr as FormPanel,
  nl as FormSubmitButton,
  _r as Help,
  _t as HelpItem,
  tl as IconMapper,
  Ta as KeycloakDataTable,
  al as KeycloakMasthead,
  Ka as KeycloakProvider,
  da as KeycloakSelect,
  Ca as KeycloakSpinner,
  Wr as KeycloakTextArea,
  ka as ListEmptyState,
  Ga as NumberControl,
  sl as OrganizationTable,
  wa as PaginatingTableToolbar,
  Wa as PasswordControl,
  qt as PasswordInput,
  na as ScrollForm,
  Hr as SelectControl,
  ue as SelectVariant,
  Qa as SwitchControl,
  Ia as TableToolbar,
  Xa as TextAreaControl,
  Za as TextControl,
  rl as UserProfileFields,
  za as beerify,
  tt as createNamedContext,
  Gr as debeerify,
  Rr as generateId,
  Er as getErrorDescription,
  Tr as getErrorMessage,
  Ha as getInjectedEnvironment,
  Ar as getNetworkErrorDescription,
  Vt as getNetworkErrorMessage,
  He as isBundleKey,
  Dr as isDefined,
  Ya as isUserProfileError,
  re as label,
  ta as mainPageContentId,
  Ja as setUserProfileServerError,
  Ua as useAlerts,
  $a as useEnvironment,
  Ht as useErrorBoundary,
  ba as useFetch,
  Nr as useHelp,
  nt as useRequiredContext,
  Fr as useSetTimeout,
  Mt as useStoredState
};
//# sourceMappingURL=keycloak-ui-shared.js.map
